import React, { useEffect, useState } from "react";
import DesignPage from "./views/DesignPage";
import * as dbm from "../utils/DBManager";
import SideNavContainer from "./SideNavContainer";
import ApiRequest from "../utils/ApiRequest";
import { createContext } from "react";
//import { useTranslation } from "react-i18next";

const designParams = {
  designstep: 0,
  boxDimensions: { B: 350, H: 180, D: 65, AL: 5, AR: 5, PB: 5, PO: 8 },
  currentRoom: {},
  currentPlint: {},
  activeModule: { module_id: -1 },
  activeGrip: { feature_id: -1, feature_price: 0 },
  activeHinge: { feature_id: -1, feature_price: 0 },
  innerMaterial: null,
  outerMaterial: null,
  slots: []
}


const DesignContext = React.createContext(designParams)


const DesignPageContainer = (props) => {

  const validationSizes = {
    minWidth: 45,
    maxWidth: 540,
    minHeight: 114,
    maxHeight: 280,
    minDepth: 35,
    maxDepth: 68,
    minBottom: 3,
    maxBottom: 20,
    minTop: 3,
    maxTop: 20,
    minLeft: 3,
    maxLeft: 20,
    minRight: 3,
    maxRight: 20,
  };

  const moduleHeights = [
    { lower: 114, upper: 140 },
    { lower: 141, upper: 190 },
    { lower: 191, upper: 240 },
    { lower: 241, upper: 280 },
  ]

  const [loading, setLoading] = useState(false)
  const [designstep, setDesignStep] = useState(0)
  // KH bodemhoogte voor zwevende kasten
  const [boxDimensions, setBoxDimensions] = useState({ B: 350, H: 180, D: 65, KH:0, AL: 5, AR: 5, PB: 5, PO: 8 });
  const [rooms, setRooms] = useState([])
  const [currentRoom, setCurrentRoom] = useState({})
  const [plints, setPlints] = useState([])
  const [currentPlint, setCurrentPlint] = useState({})
  const [helps, setHelps] = useState([])
  const [materials, setMaterials] = useState([])
  const [features, setFeatures] = useState([])
  const [featureTypes, setFeatureTypes] = useState([])
  const [modules, setModules] = useState([])
  const [moduleList, setModuleList] = useState({ single: [], double: [] })
  const [settings, setSettings] = useState([])
  const [activeModule, setActiveModule] = useState({ module_id: -1 })
  const [activeGrip, setActiveGrip] = useState({ feature_id: -1, feature_price: 0 })
  const [activeHinge, setActiveHinge] = useState({ feature_id: -1, feature_price: 0 })
  const [innerMaterial, setInnerMaterial] = useState(null)
  const [outerMaterial, setOuterMaterial] = useState(null)
  const [orientationPopup, setOrientationPopup] = useState(false)
  const [slots, setSlots] = useState([])
  const [wallcolor, setWallColor] = useState('#d1c4a1')
  const [total_price, setTotalPrice] = useState(0)

  const [base_price, setBasePrice] = useState(0)

  const [errors, setErrors] = useState({})
  const [customer, setCustomer] = useState({ name: "", email: "", btw: "", delivery_street: "", delivery_number: "", delivery_zip: "", delivery_city: "", invoice_street: "", invoice_number: "", invoice_zip: "", invoice_city: "" })
  //const { t } = useTranslation();

  useEffect(() => {

    dbm.readAllModules(onReceiveModules);
    dbm.readAllMaterials(onReceiveMaterials)
    dbm.readAllRooms(onReceiveRooms);
    dbm.readAllPlints(onReceivePlints);
    dbm.readSettings(onReceiveSettings)
    dbm.readFeatures(onReceiveFeatures)
    dbm.readFeatureTypes(onReceiveFeatureTypes)
    dbm.readAllHelp(onReceiveHelp)

    if (window.screen.orientation !== undefined) {
      //Check if orientation is supported/defined for this browser
      if (window.innerWidth < 600 && (window.screen.orientation.type === "portrait-primary" || window.screen.orientation.type === "portrait-secondary")) {
        // Pop-up 'Change Screen orientation)
        setOrientationPopup(true)
      }
    }

    window.addEventListener("resize", _handleResize);
    window.addEventListener("orientationchange", _handleRotation); // will only trigger on mobile phones

    return () => {
      window.removeEventListener("resize", _handleResize);
      window.removeEventListener("orientationchange", _handleRotation);
    }
  }, [])

  useEffect(() => {
    let height = boxDimensions.H
    moduleHeights.forEach(range => {
      if (height <= range.upper && height >= range.lower)
        filterModulesByHeightRange(range)
    })
  }, [moduleList])

  useEffect(() => {
    calculatePrice()
  }, [innerMaterial, outerMaterial, activeGrip, activeHinge, slots])

  function closePopup() {
    setOrientationPopup(false)
  };

  function _handleResize() {
    if (window.innerWidth < 600) {
      setOrientationPopup(true)
    } else {
      setOrientationPopup(false)
    }
  }

  function _handleRotation() {
    if (window.screen.orientation !== undefined) {
      if (window.screen.orientation.type === "portrait-primary" || window.screen.orientation.type === "portrait-secondary") {
        setOrientationPopup(true)
      } else {
        setOrientationPopup(false)
      }
    }
  }

  function filterModulesByHeightRange(range) {

    let filteredModules = {
      single: [],
      double: []
    }

    moduleList.single.forEach(module => {
      if (module.module_model_height < range.upper && module.module_model_height >= range.lower) {
        filteredModules.single.push(module)
      }
    })

    moduleList.double.forEach(module => {
      if (module.module_model_height < range.upper && module.module_model_height >= range.lower) {
        filteredModules.double.push(module)
      }
    })

    setModules(filteredModules)
  }

  function onReceiveModules(modules) {
    let singleModules = []
    let doubleModules = []

    modules.forEach(module => {
      if (module.module_size === 1)
        singleModules.push(module)
      else if (module.module_size === 2)
        doubleModules.push(module)
    });
    console.log("single: " + singleModules);
    setModuleList({ single: singleModules, double: doubleModules })
  }

  function onReceiveMaterials(materials) {
    setMaterials(materials)
  }

  function onReceiveRooms(rooms) {
    setRooms(rooms)
  }

  function onReceivePlints(plints) {
    setPlints(plints)
  }

  function onReceiveSettings(settings) {
    setSettings(settings[0])
  }

  function onReceiveFeatures(features) {
    setFeatures(features)
  }

  function onReceiveFeatureTypes(featureTypes) {
    setFeatureTypes(featureTypes)
  }

  function onReceiveHelp(helps) {
    setHelps(helps)
  }

  function calculatePrice(tempSlots = slots) {

    let basePrice = +base_price;
    let modulePrice = 0
    let doorCount = 0
    let drawerCount = 0;

    tempSlots.forEach(slot => {
      if (slot.moduleData !== undefined && slot.moduleData !== null) {
        let slotBasePrice = +slot.moduleData.module_base_price
        console.log(slot.moduleData.scale)
        let widthScale = slot.moduleData.module_width_price_scale * (slot.moduleData.scale.width - 1) * slotBasePrice;
        let depthScale = slot.moduleData.module_depth_price_scale * (slot.moduleData.scale.depth - 1) * slotBasePrice;
        let heightScale = slot.moduleData.module_height_price_scale * (slot.moduleData.scale.height - 1) * slotBasePrice;
        let slotScaledPrice = slotBasePrice + widthScale + depthScale + heightScale;
        modulePrice += slotScaledPrice;
        console.log("*** module kps name: " + slot.moduleData.module_kps_name);
/*
        let doorIndex = slot.moduleData.module_kps_name.indexOf('D');
        let door = slot.moduleData.module_kps_name.substr(doorIndex, 2);
        switch (door) {
          case 'D0':
            break;
          case 'D1':
            doorCount += 1
            break;
          case 'D2':
            doorCount += 2
            break;
          default:
            break;
        }
*/
        let hd = slot.moduleData.module_has_door;
        let ds = slot.moduleData.module_size;
        let al = slot.moduleData.module_drawer;
        if(hd !== undefined && hd !== null && hd !== '0') {
          if(ds === 2) {
            doorCount += 2
          }
          else {
            doorCount += 1
          }
        }
        if(al !== undefined && al !== null && al !== 0) {
          drawerCount += al;
        }

        // console.log(slot.moduleData)
      }
    })

    // Material Price modification
    if (innerMaterial !== null) {
      modulePrice *= innerMaterial.material_price_scale
    }

    if (outerMaterial !== null) {
      basePrice *= outerMaterial.material_price_scale
    }
    // console.log(doorCount)
    let totalPrice = basePrice + modulePrice + (doorCount * activeGrip.feature_price) + (drawerCount * activeGrip.feature_price);

    totalPrice = Math.round((totalPrice + Number.EPSILON) * 100) / 100

    // Decide whether or not the price should be updated
    setTotalPrice(totalPrice)
  }

  function updateActiveGrip(newGrip) {
    setActiveGrip(newGrip)
  }

  function updateActiveModule(newModule) {
    setActiveModule(newModule)
    setLoading(true)
  }

  function updateActiveHinge(newHinge) {
    setActiveHinge(newHinge)
  }

  function updateInnerMaterial(material) {
    setInnerMaterial(material)
  }

  function updateOuterMaterial(material) {
    setOuterMaterial(material)
  }

  function updateBoxDimensions(type, value) {
    if (!validateDimension(type, value)) return

    let numberVal = value || 0;

    let boxDimension = { ...boxDimensions }
    boxDimension[type] = parseInt(numberVal)
    setBoxDimensions(boxDimension)

    if (type === "H") {
      moduleHeights.forEach(range => {
        if (value <= range.upper && value >= range.lower)
          filterModulesByHeightRange(range)
      })
    } else if (type === "B") {
      let width = value * 10;
      plints.forEach(plint => {
        if (plint.room_id === currentRoom.room_id) {
          if (plint.min_width < width && width < plint.max_width) {
            setCurrentPlint(plint)
            setBasePrice(plint.base_price)
          }
        }
      })
    }
  }

  function updateSlots(slots) {
    // console.log(slots)
    setSlots(slots)
  }

  function validateDimension(type, value) {
    switch (type) {
      case "B":
        if (value < validationSizes.minWidth || value > validationSizes.maxWidth) return false;
        else return true;
      case "H":
        if (value < validationSizes.minHeight || value > validationSizes.maxHeight) return false;
        else return true;
      case "D":
        if (value < validationSizes.minDepth || value > validationSizes.maxDepth) return false;
        else return true;
      case "AL":
        if (value < validationSizes.minLeft || value > validationSizes.maxLeft) return false;
        else return true;
      case "AR":
        if (value < validationSizes.minRight || value > validationSizes.maxRight) return false;
        else return true;
      case "PO":
        if (value < validationSizes.minBottom || value > validationSizes.maxBottom) return false;
        return true
      case "PB":
        if (value < validationSizes.minTop || value > validationSizes.maxTop) return false;
        return true
      default:
        return false;
    }
  }

  function filterModulesByHeightRange(range) {
    let filteredModules = {
      single: [],
      double: []
    }

    moduleList.single.forEach(module => {
      if (module.module_model_height < range.upper && module.module_model_height >= range.lower) {
        filteredModules.single.push(module)
      }
    })

    moduleList.double.forEach(module => {
      if (module.module_model_height < range.upper && module.module_model_height >= range.lower) {
        filteredModules.double.push(module)
      }
    })

    setModules(filteredModules)
  }

  function updateDesignStep(isNext) {
    isNext ? setDesignStep(designstep + 1) : setDesignStep(designstep - 1)

  }

  function updateTotalPrice(price) {
    setTotalPrice(price)
  }

  function updateActiveRoom(room) {
    let temporaryPlintObject = {}
    let temporaryBoxDimensions = {}

    plints.forEach(plint => {
      if (plint.room_id === room.room_id) {
        let width = boxDimensions.B * 10;
        // console.log(width)
        if (plint.min_width < width && width < plint.max_width) {
          temporaryPlintObject = plint
        }
      }
    })

    if(room.room_description.includes("Lage")) {
      boxDimensions.H = 114;
      var range = [ { lower: 114, upper: 140 }, ];
    }
    else {
      boxDimensions.H = 250;
      var range = [ { lower: 241, upper: 280 }, ];
    }

    let filteredModules = {
      single: [],
      double: []
    };
    moduleList.single.forEach(module => {
      if (module.module_model_height < range[0].upper && module.module_model_height >= range[0].lower) {
        filteredModules.single.push(module);
      }
    });
    moduleList.double.forEach(module => {
      if (module.module_model_height < range[0].upper && module.module_model_height >= range[0].lower) {
        filteredModules.double.push(module);
      }
    });
    setModules(filteredModules);

    temporaryBoxDimensions = boxDimensions;
    boxDimensions.AL = temporaryPlintObject.left_dim / 10
    boxDimensions.AR = temporaryPlintObject.right_dim / 10
    boxDimensions.PB = temporaryPlintObject.top_dim / 10
    boxDimensions.PO = temporaryPlintObject.bottom_dim / 10

    setCurrentRoom(room)
    setCurrentPlint(temporaryPlintObject)
    setBoxDimensions(temporaryBoxDimensions)
    setBasePrice(temporaryPlintObject.base_price)
    setTotalPrice(temporaryPlintObject.base_price)
    setDesignStep(1)
  }

  function updateWallColor(color) {
    setWallColor(color)
  }

  function clearCustomerFormErrors() {
    setCustomer({ name: "", email: "", btw: "", delivery_street: "", delivery_number: "", delivery_zip: "", delivery_city: "", invoice_street: "", invoice_number: "", invoice_zip: "", invoice_city: "" })
    setErrors({})
  }

  function _validOrder(event) {
    let errors = {}
    let orderIsValid
    generateOrderJSON(errors)

    if (Object.keys(errors).length > 0) {
      orderIsValid = false;
    }

    setErrors(errors)

    return orderIsValid
  }

  function _validCustomerForm(event) {
    let customer = { name: "", email: "", btw: "", delivery_street: "", delivery_number: "", delivery_zip: "", delivery_city: "", invoice_street: "", invoice_number: "", invoice_zip: "", invoice_city: "" }
    let errors = {};
    let formIsValid = true;

    let formData = new FormData(event.target)

    let customerName = formData.get("customer_name");
    let customerEmail = formData.get("customer_email");
    let customerBtw = formData.get("customer_btw");

    let customerDeliveryStreet = formData.get("customer_delivery_street");
    let customerDeliveryNumber = formData.get("customer_delivery_number");
    let customerDeliveryZip = formData.get("customer_delivery_zip");
    let customerDeliveryCity = formData.get("customer_delivery_city");

    let customerInvoiceEqualsDelivery = formData.get("customer_invoice_equals_delivery");

    let customerInvoiceStreet = formData.get("customer_invoice_street");
    let customerInvoiceNumber = formData.get("customer_invoice_number");
    let customerInvoiceZip = formData.get("customer_invoice_zip");
    let customerInvoiceCity = formData.get("customer_invoice_city");


    if (customerName !== "") {
      customer.name = customerName;
    } else {
//      errors["customer_name"] = t('naamverplicht');
      errors["customer_name"] = "Naam is een verplicht veld";
    }

    if (customerEmail !== "") {
      customer.email = customerEmail;
    } else {
//      errors["customer_email"] = t('emailverplicht');
      errors["customer_email"] = "E-mail is een verplicht veld";
    }

    customer.btw = customerBtw;

    // Delivery (Bezorg)
    if (customerDeliveryStreet !== "") {
      customer.delivery_street = customerDeliveryStreet;
    } else {
//      errors['customer_delivery_street'] = t('straatverplicht');
      errors['customer_delivery_street'] = 'Straatnaam is een verplicht veld';
    }

    if (customerDeliveryNumber !== "") {
      customer.delivery_number = customerDeliveryNumber;
    } else {
//      errors['customer_delivery_number'] = t('huisnummerverplicht');
      errors['customer_delivery_number'] = 'Huisnummer en/of bus is een verplicht veld';
    }

    if (customerDeliveryZip !== "") {
      customer.delivery_zip = customerDeliveryZip;
    } else {
//      errors['customer_delivery_zip'] = t('postcodeverplicht');
      errors['customer_delivery_zip'] = 'Postcode is een verplicht veld';
    }

    if (customerDeliveryCity !== "") {
      customer.delivery_city = customerDeliveryCity;
    } else {
//      errors['customer_delivery_city'] = t('gemeenteverplicht');
      errors['customer_delivery_city'] = 'Gemeente is een verplicht veld';
    }

    if (!customerInvoiceEqualsDelivery) {
      // Invoice (Factuur)
      if (customerInvoiceStreet !== "") {
        customer.invoice_street = customerInvoiceStreet;
      } else {
//        errors['customer_invoice_street'] = t('straatverplicht');
        errors['customer_invoice_street'] = 'Straatnaam is een verplicht veld';
      }

      if (customerInvoiceNumber !== "") {
        customer.invoice_number = customerInvoiceNumber;
      } else {
//        errors['customer_invoice_number'] = t('huisnummerverplicht');
        errors['customer_invoice_number'] = 'Huisnummer en/of bus is een verplicht veld';
      }

      if (customerInvoiceZip !== "") {
        customer.invoice_zip = customerInvoiceZip;
      } else {
//        errors['customer_invoice_zip'] = t('postcodeverplicht');
        errors['customer_invoice_zip'] = 'Postcode is een verplicht veld';
      }

      if (customerInvoiceCity !== "") {
        customer.invoice_city = customerInvoiceCity;
      } else {
//        errors['customer_invoice_city'] = t('gemeenteverplicht');
        errors['customer_invoice_city'] = 'Gemeente is een verplicht veld';
      }
    } else {
      customer.invoice_street = customerDeliveryStreet;
      customer.invoice_number = customerDeliveryNumber;
      customer.invoice_zip = customerDeliveryZip;
      customer.invoice_city = customerDeliveryCity;
    }

    generateOrderJSON(errors)

    console.log(errors)

    if (Object.keys(errors).length > 0) {
      formIsValid = false;
    }

    setErrors(errors)
    setCustomer(customer)

    return formIsValid;
  }

  function submitOrderVlecad(modulesVlecad, moduleNr) {
    const current = new Date();
    let formData = new FormData();
    formData.set("mod_namen", modulesVlecad);
    formData.set("mod_aantal", moduleNr);
    formData.set("mod_price", total_price);
    formData.set("mod_date", current.getFullYear()+"-"+(current.getMonth()+1)+"-"+current.getDate());

    ApiRequest.axiosInstance({
      method: "post",
      url: "/order/submitOrderVlecad.php",
      data: formData,
      headers: { "Content-Type": "multipart/form-data" }
    })
      .then(res => {
        console.log("submitOrderVlecad ok");
      })
      .catch((err) => {
        console.log("error submit order vlecad: " + err);
      })
      .then(() => {
        console.log("Order Vlecad submit request finished.");
      });
  }

  function submitOrder(event) {
    event.preventDefault()
    if (_validCustomerForm(event)) {
      let formData = new FormData(event.target)

      // Add Order details to CustomerForm
      if (formData.get("customer_invoice_equals_delivery")) {
        formData.set("customer_invoice_street", formData.get("customer_delivery_street"));
        formData.set("customer_invoice_number", formData.get("customer_delivery_number"));
        formData.set("customer_invoice_zip", formData.get("customer_delivery_zip"));
        formData.set("customer_invoice_city", formData.get("customer_delivery_city"));
      }

      formData.set("order_json", generateOrderJSON({}));
      formData.set("order_price", total_price);
      formData.set("order_discount_code", formData.get("discount_code"));

      if (settings.valid_api_key) {
        ApiRequest.axiosInstance({
          method: "post",
          url: "/order/submitOrder.php",
          data: formData,
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
          .then(res => {
            console.log(res)
            console.log(ApiRequest.callSuccess(res))
            console.log(ApiRequest.callHasRecords(res))

            if (ApiRequest.callSuccess(res) && ApiRequest.callHasRecords(res)) {
              //Handle succesful request
              console.log(res.data.records[5])
              let url = res.data.records[5]
              if (url !== undefined && url !== null) {
                window.open(url, '_blank');
              }
              const modulesVlecad = [];
              let moduleNr = 0;
              slots.forEach(slot => {
                if (slot.moduleData !== null && slot.moduleData !== undefined) {
                  modulesVlecad.push(slot.moduleData.module_kps_name);
                  if(slot.moduleData.module_size === 1) {
                    moduleNr += 1;
                  }
                  else if(slot.moduleData.module_size === 2) {
                    moduleNr += 2;
                  }
                }
              });
              
              submitOrderVlecad(modulesVlecad, moduleNr);
            }
            else {
              let temporaryErrors = errors;
              temporaryErrors["submitError"] = res.data.message !== undefined ? res.data.message : "Er is iets fout gegaan. Probeer het nog eens";
              setErrors(temporaryErrors)
            }
          })
          .catch((err) => {
            console.error(err);
            let temporaryErrors = errors;
            temporaryErrors["submitError"] = err.response.data.message !== undefined ? err.response.data.message : "Er is iets fout gegaan. Probeer het nog eens";
            setErrors(temporaryErrors)
          })
          .then(() => {
            console.log("Order 'Submit' Request Finished");
          });
      }
      else {
        console.log("No valid APIKey");
      }
    }
  }

  function generateOrderJSON(errors) {
    let roomBasePath = settings.settings_room_kps_path
    let moduleBasePath = settings.settings_module_kpo_path
    let featureBasePath = settings.settings_feature_kpo_path

    let templateName = roomBasePath + "K"

    let isFirstSlot = true;

    let replaceObjects = [];
    let objectIndex = 1;

    let moduleSlotCount = 0;
    let hasDoors = false;

    slots.forEach(slot => {
      // console.log(slot)
      if (slot.moduleData !== null && slot.moduleData !== undefined) {
        let hd = slot.moduleData.module_has_door;
        if(hd !== undefined && hd !== null && hd !== '0') {
          hasDoors = true;
        }

        if (slot.moduleData.module_size === 1) {
          if (isFirstSlot)
            templateName += "1"
          else
            templateName += "_1"

          moduleSlotCount += 1;
        }
        if (slot.moduleData.module_size === 2) {
          if (isFirstSlot)
            templateName += "2"
          else
            templateName += "_2"

          moduleSlotCount += 2;
        }

        // replaceObject
        let obj = {
          "ObjectFile": "M" + objectIndex + ".Kpo",
          "NewValue": slot.moduleData.module_kps_path + slot.moduleData.module_kps_name
        }
        objectIndex++

        replaceObjects.push(obj);

      }
      isFirstSlot = false
    })

    if (moduleSlotCount !== slots.length) {
      // Less module slots than slots in the closet --> Closet not filled up.
      errors["order_error"] = "Gelieve de kast volledig op te vullen."
    }

    templateName += "M.Kps"

    replaceObjects.push(
      {
        "ObjectFile": "AFW_L.Kpo",
        "NewValue": moduleBasePath + currentPlint.left_kpo
      }
    )

    replaceObjects.push(
      {
        "ObjectFile": "AFW_R.Kpo",
        "NewValue": moduleBasePath + currentPlint.right_kpo
      }
    )

    replaceObjects.push(
      {
        "ObjectFile": "PL_O.Kpo",
        "NewValue": moduleBasePath + currentPlint.bottom_kpo
      }
    )

    replaceObjects.push(
      {
        "ObjectFile": "PL_B.Kpo",
        "NewValue": moduleBasePath + currentPlint.top_kpo
      }
    )

    let replaceMaterial = []

    if (innerMaterial !== null) {

      innerMaterial.material_replacements.forEach(material => {
        if (material.material_type === "inner")
          replaceMaterial.push({
            "MaterialName": material.material_replace_variable,
            "NewValue": material.material_real_name
          })
      });
    } else {
      if(errors["order_error"] !== null && errors["order_error"] !== undefined) {
        errors["order_error"] = errors["order_error"] + "/n" + "Gelieve een kleur te kiezen voor de binnenkant van de kast."
      }
      else {
        errors["order_error"] = "Gelieve een kleur te kiezen voor de binnenkant van de kast."
      }
    }

    if (outerMaterial !== null) {

      outerMaterial.material_replacements.forEach(material => {
        if (material.material_type === "outer")
          replaceMaterial.push({
            "MaterialName": material.material_replace_variable,
            "NewValue": material.material_real_name
          })
      });
    } else {
      if(errors["order_error"] !== null && errors["order_error"] !== undefined) {
        errors["order_error"] = errors["order_error"] + "/n" + "Gelieve een kleur te kiezen voor de buitenkant van de kast.";
      }
      else {
        errors["order_error"] = "Gelieve een kleur te kiezen voor de buitenkant van de kast.";
      }
    }

    if(activeGrip.feature_id !== -1) {
    }
    else {
      if(hasDoors) {
        if(errors["order_error"] !== null && errors["order_error"] !== undefined) {
          errors["order_error"] = errors["order_error"] + "/n" + "Gelieve een greep te kiezen.";
        }
        else {
          errors["order_error"] = "Gelieve een greep te kiezen.";
        }
      }
    }

    let replaceVariable = []

    replaceVariable.push(
      {
        "VariableName": "KAST_DIEPTE",
        "NewValue": boxDimensions.D * 10 + '.0'
      },
      {
        "VariableName": "AFWERK_LINKS",
        "NewValue": boxDimensions.AL * 10 + '.0'
      },
      {
        "VariableName": "AFWERK_RECHTS",
        "NewValue": boxDimensions.AR * 10 + '.0'
      },
      {
        "VariableName": "PLINT_ONDER",
        "NewValue": boxDimensions.PO * 10 + '.0'
      },
      {
        "VariableName": "PLINT_BOVEN",
        "NewValue": boxDimensions.PB * 10 + '.0'
      }
    )
    let replaceMount = []

    replaceMount.push(
      {
        "MountName": "KPWEB\\KPWEB_GREEP_DEUR",
        "NewValue": activeGrip.feature_kmt_name
      })

    let orderObject = {
      KorpusInputType: "KORPUS_JSON_V1_VLECAD",
      Documents: [
        {
          File: templateName,
          Xsize: boxDimensions.B * 10 + '.0',
          Zsize: boxDimensions.H * 10 + '.0',
          ReplaceVariables: replaceVariable,
          ReplaceObjects: replaceObjects,
          ReplaceMaterials: replaceMaterial,
          ReplaceMount: replaceMount
        }
      ]
    }

    let orderJSON = JSON.stringify(orderObject)

    console.log(orderJSON)
    return orderJSON
  }

  let closetProps = {
    innerMaterial: innerMaterial,
    outerMaterial: outerMaterial,
    activeModule: activeModule,
    activeGrip: activeGrip
  };

  // console.log(designstep)
  return (
    <DesignContext.Provider>
      <DesignPage
        loading={loading}
        updateLoading={setLoading}
        orientationPopup={orientationPopup}
        closePopup={closePopup}

        formErrors={errors}
        clearCustomerFormErrors={clearCustomerFormErrors}

        validationSizes={validationSizes}

        designstep={designstep}
        updateDesignStep={updateDesignStep}

        boxDimensions={boxDimensions}
        setBoxDimensions={updateBoxDimensions}
        closetProps={closetProps}

        setInnerMaterial={updateInnerMaterial}
        setOuterMaterial={updateOuterMaterial}


        activeGrip={activeGrip}

        slots={slots}
        updateSlots={updateSlots}

        modules={modules}
        materials={materials}
        features={features}
        featureTypes={featureTypes}
        helps={helps}

        rooms={rooms}
        setRoom={updateActiveRoom}
        currentRoom={currentRoom}
        currentPlint={currentPlint}
        wallColor={wallcolor}
        setWallColor={updateWallColor}

        setActiveModule={updateActiveModule}
        setActiveGrip={updateActiveGrip}
        generateOrderJSON={generateOrderJSON}
        submitOrder={submitOrder}

        calculatePrice={calculatePrice}
        totalPrice={total_price}
        basePrice={base_price}
      />
    </DesignContext.Provider>
  )
}

export default DesignPageContainer;


// TODO::
/**
 * Check Context Implementation (React Context => replaces this.state)
 * */